var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWidgetsmiley(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1826_26599)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z",
    fill: "#FCBD24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2266 16.2734C30.5366 16.2734 29.9766 15.7134 29.9766 15.0234C29.9766 13.6459 28.8566 12.5234 27.4766 12.5234C26.0966 12.5234 24.9766 13.6459 24.9766 15.0234C24.9766 15.7134 24.4166 16.2734 23.7266 16.2734C23.0366 16.2734 22.4766 15.7134 22.4766 15.0234C22.4766 12.2659 24.7191 10.0234 27.4766 10.0234C30.2341 10.0234 32.4766 12.2659 32.4766 15.0234C32.4766 15.7159 31.9166 16.2734 31.2266 16.2734Z",
    fill: "#6D4C41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2266 16.2734C15.5366 16.2734 14.9766 15.7134 14.9766 15.0234C14.9766 13.6459 13.8541 12.5234 12.4766 12.5234C11.0991 12.5234 9.97656 13.6459 9.97656 15.0234C9.97656 15.7134 9.41656 16.2734 8.72656 16.2734C8.03656 16.2734 7.47656 15.7134 7.47656 15.0234C7.47656 12.2659 9.71906 10.0234 12.4766 10.0234C15.2341 10.0234 17.4766 12.2659 17.4766 15.0234C17.4766 15.7159 16.9166 16.2734 16.2266 16.2734Z",
    fill: "#6D4C41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1963 23.0209C33.9588 22.7084 33.5913 22.5234 33.2013 22.5234H6.75132C6.35882 22.5234 5.99132 22.7059 5.75632 23.0184C5.51632 23.3334 5.44132 23.7359 5.54632 24.1134C7.35382 30.5359 13.2888 35.0234 19.9738 35.0234C26.6588 35.0234 32.5938 30.5359 34.4013 24.1134C34.5088 23.7359 34.4338 23.3334 34.1963 23.0209Z",
    fill: "#FAFAFA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1826_26599"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWidgetsmiley);
export default __webpack_public_path__ + "static/media/widgetsmiley.9f613b80a992b424fb88a1a280adba41.svg";
export { ForwardRef as ReactComponent };